import UserPersistence from "../persistence/UserPersistence";
import ArrayUtils from "./utils/ArrayUtils";
import {ALONE_APP_MODE, APP_MODE, ENV} from "../config/app";

/**
 * 判断是否有按钮权限
 * @param routerUrl
 * @param buttonList
 * @returns {boolean[]}
 */

export function isButtonRole(routerUrl, buttonList) {
  if (!routerUrl || !buttonList || buttonList.length === 0) return [];
  let menuList = UserPersistence.getBaseInfo().menuList;
  let router = ArrayUtils.getItemBy(menuList, 'routeUrl', routerUrl);
  if (router) {
    let buttonRoleList = menuList.filter((item) => {
      return item.parentId === router.id;
    });
    if (buttonList.length > 0) {
      let role = [];
      buttonList.forEach((item) => {
        role.push(!!ArrayUtils.getItemBy(buttonRoleList, 'routeUrl', item))
      });
      return role;
    }
  }
  return []
}


/**
 * 判断是否有菜单权限
 */

export function isMenuRole(routerUrl) {
  return ArrayUtils.getItemBy(UserPersistence.getBaseInfo().menuList, 'routeUrl', routerUrl);
}


/**
 * 判断是否教育考试环境
 * @returns {boolean}
 */
export function isEduKS() {
  return ENV.MODE === APP_MODE.EDU_KSUAT ||
    ENV.MODE === APP_MODE.EDU_KS ||
    ENV.MODE === APP_MODE.EDU_DX2  //单项2 改为考试2但项目名称、接口地址都没改变
}


/**
 * 判断系统展现形式
 * @returns {boolean}
 */
export function isAlone() {
  return UserPersistence.getAppMode() === ALONE_APP_MODE
}
/**
 * 银行科目 科目编码
 */

export function bankSubjectCode(type) {
  const code = isThrAccStandard()? 102 : 1002;
  return type === 'str'? (code + '') : code;
}

/**
 * 现金科目 科目编码
 */

export function cashSubjectCode(type) {
  const code = isThrAccStandard()? 101 : 1001;
  return type === 'str'? (code + '') : code;
}

export function isEdu(type) {
  return false
}




// WEBPACK FOOTER //
// ./src/libs/check.js